import {HStack, Icon, Space, Text, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import i18n from '../../i18n/i18n';
import {FormattedComment} from '../FormattedComment/FormattedComment';
import {InspectionReport} from '../InspectionReport/InspectionReport';
import {getInspectionReport} from '../InspectionReport/utils/getInspectionReport';

interface CommentProps extends TestIdProps {
  title?: string;
  comment?: string | Nullish;
}

export function Comment(props: CommentProps) {
  const report = getInspectionReport(props.comment);

  // The report carries its own headings, so the generic comment title is left out.
  if (isNotNil(report)) {
    return <InspectionReport report={report} data-testid={suffixTestId('comment', props)} />;
  }

  return (
    <VStack>
      <HStack spacing={4} align="center">
        <Icon value="comment" size={6} color="accent.base" />
        <Text size="base">{props.title ?? i18n.t('comment')}</Text>
      </HStack>
      <Space vertical={3} />
      <FormattedComment comment={props.comment} data-testid={suffixTestId('comment', props)} />
    </VStack>
  );
}
